import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { Datagrid, DatagridColumn } from '@zipari/shared-ds-util-datagrid';
import { FormattingService } from '../../../shared/services/formatting.service';
import { getValue } from '../../../shared/utils/get-value';

@Component({
  selector: 'datagrid-body',
  templateUrl: './datagrid-body.component.html',
  styleUrl: './datagrid-body.component.scss',
})
export class DatagridBodyComponent {
  @Input() data: object[];
  @Input() isLoading: boolean;
  @Input() hasAnErrorOccurred: boolean;
  @Input() config: Datagrid;
  @Input() rows: object[];
  @Input() dataGridId: string;
  @Input() error: TemplateRef<any>;
  @Input() noData: TemplateRef<any>;
  @Input() cellOptions: TemplateRef<any>;
  @Input() selectedRows: object[] = [];
  @Output() datagridRowClicked = new EventEmitter<object>();
  @Output() selectedRowsChange = new EventEmitter<object[]>();

  constructor(private formattingService: FormattingService) {}

  isRowSelected(row) {
    return this.selectedRows.includes(row);
  }

  toggleRow(event, row) {
    event.stopPropagation();
    event.preventDefault();
    !this.isRowSelected(row)
      ? this.selectedRows.push(row)
      : this.selectedRows.splice(this.selectedRows.indexOf(row), 1);
    this.selectedRowsChange.emit(this.selectedRows);
  }

  getColumnWidth(column: DatagridColumn) {
    return column.width && this.rows.length > 0 && column.width;
  }
  getFormattedToolTipValue(row: object, column: Partial<DatagridColumn>): any {
    const formattedValue = this.formattingService.restructureValueBasedOnFormat(
      getValue(row, column.tooltipProp),
      column,
      'TEXT',
    );

    return formattedValue === 0 ? '0' : formattedValue;
  }
}
